<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>{{data.title}}</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          전시 관리
        </li>
        <li class="breadcrumb-item active">
          <a :href="data.url">{{data.title}}</a>
        </li>
      </ol>
    </div>
    <div class="card card-default" v-show="data.params.mode=='list'">
      <div class="card-body">
        <div class="form-row align-items-center">
          <div class="form-group no-margin row" style="width:100%">
            <div v-if="type=='channelBanner'" class="col-auto">
              <label class="col-form-label">배너위치</label>
            </div>
            <div v-if="type=='channelBanner'" class="col-auto">
                <b-form-select @change="search(1)" class="custom-select custom-select-sm" :options="data.imageDivOption.array" v-model="data.params.imageDivCd"></b-form-select>
            </div>

            <div class="col-auto">
              <label class="col-form-label">채널</label>
            </div>
            <div class="col-auto">
                <b-form-select @change="search(1)" class="custom-select custom-select-sm" :options="data.bannerCategorys.array" v-model="data.params.boardCatSeq"></b-form-select>
            </div>
             <!-- 항목 검색 -->
             <sch-text label="검색어" :type="'no'" :data="data" @search="search(1)" @reset="reset"/>
          </div>  
          <div v-if="type=='brandBanner'" class="col-auto mr-4">
              <input type="checkbox" class="ml-1" v-model="data.selectAllUserType">
              <label class="form-check-label ml-2">노출허용 전체</label>
              <input type="checkbox" class="ml-3" v-model="data.params.teacherUseYn" true-value="Y" false-value="" >
              <label class="form-check-label ml-2">학교교사</label>
              <input type="checkbox" class="ml-3" v-model="data.params.tutorUseYn" true-value="Y" false-value="" >
              <label class="form-check-label ml-2">학원강사</label>
              <input type="checkbox" class="ml-3" v-model="data.params.studentUseYn" true-value="Y" false-value="" >
              <label class="form-check-label ml-2">학생</label>
              <input type="checkbox" class="ml-3" v-model="data.params.parentsUseYn" true-value="Y" false-value="" >
              <label class="form-check-label ml-2">학부모</label>
          </div>
          <div class="col-auto">
            <label class="col-form-label">전시여부</label>
          </div>
          <div class="col-auto">
            <b-form-select @change="search(1)" class="custom-select custom-select-sm mt-1" style="width: max-content;" :options="data.exhibitionYns.array" v-model="data.params.exhibitionStatus"></b-form-select>
          </div>
        </div>
      </div>
    </div>
    <!-- // 검색 -->

    <!-- 목록 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">목록</span>
        <div class="card-tool float-right" >
          <b-btn class="btn btn-xs btn-outline-info mr-2" :disabled="!data.enabledSaveExhibition" variant="outline-primary" style="width:150px;" @click="saveExhibition();">변경사항 프론트 반영</b-btn>
          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="goDetail(0)" >등록</b-btn>
        </div>
        <ShowCounter label="Show" class="ml-1" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td width="2%" style="text-align:center"><input type="checkbox" v-model="data.selectAllBanner" /></td>
              <td width="4%" style="text-align:center">No</td>
              <td width="10%" style="text-align:center" >채널</td>
              <td v-if="type=='brandBanner'" width="10%" style="text-align:center" >회원정보</td>
              <td width="10%" style="text-align:center" >이미지 URL</td>
              <td style="text-align:center" @click="localSort.sort('title')" >배너명<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="10%" style="text-align:center" >배너위치</td>
              <td width="10%" style="text-align:center" >전시여부 (Y/N)</td>
              <td width="10%" style="text-align:center" @click="localSort.sort('orderNum')">노출순서<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="10%" style="text-align:center" @click="localSort.sort('startDt')">전시 시작일<em class="fa-2s mr-2 fas fa-sort"></em></td>
              <td width="10%" style="text-align:center" @click="localSort.sort('endDt')">전시 종료일<em class="fa-2s mr-2 fas fa-sort"></em></td>
            </tr>
          </thead>
          <tbody>
            <tr v-show="data.count==0" class="text-center"><td colspan="11">No matching records</td> </tr>
            <template v-for="(item, index) in data.list">
              <tr :key="index">
                <td class="align-middle text-center"><input type="checkbox" v-model="data.selectedBanners" :value="item.seq" /></td>
                <td class="align-middle text-center" @click="goDetail(item.seq)">{{data.params.limit*(data.params.page-1) + index+1}}</td>
                <td class="align-middle text-center" @click="goDetail(item.seq)">{{data.bannerCategorys.getText(item.boardCatSeq)}}</td>
                <td v-if="type=='brandBanner'" class="align-middle text-center" @click="goDetail(item.seq)">{{item.bannerUserTypes}}</td>
                <td class="align-middle text-center"  style="width: 194px;height: 75px;padding: 5px;" @click="goDetail(item.seq)">
                  <img  style="width: auto;height: 100%;" :src="item.webUrl"/>
                </td>
                <td class="align-middle text-center" @click="goDetail(item.seq)">{{item.title}}</td>
                <td class="align-middle text-center" @click="goDetail(item.seq)">
                  {{type=='brandBanner' ? '메인-상단띠배너' : data.imageDivOption.getText(item.imageDivCd)}}
                </td>
                <td class="align-middle text-center">
                    <b-form-select class="custom-select custom-select-sm mt-1" style="width: max-content;" :options="data.exhibitionYns.noEmptyArray" v-model="item.exhibitionStatus"></b-form-select>
                </td>
                <td class="align-middle text-center">
                    <input type="text" :class="{'text-center form-control':true, 'is-invalid':errors.has(`orderNum_${item.seq}`)}" 
                      v-validate="'min_value:1'"
                      v-model="item.orderNum" :name="`orderNum_${item.seq}`" style="width: 60px;margin: 0 auto;"/>
                </td>
                <td class="align-middle text-center" @click="goDetail(item.seq)">{{item.startDt != null ? item.startDt.substr(0,10) : ''}}</td>
                <td class="align-middle text-center" @click="goDetail(item.seq)">{{item.endDt != null ? item.endDt.substr(0,10) : ''}}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->
    
    <loading :active="modalLoading" :is-full-page="true"/>
  </ContentWrapper>    
</template>

<script>
import Vue from 'vue';
import store from "@/store/index";
import { reactive, ref, watch, computed, onMounted } from '@vue/composition-api'
import {dataObject, ValueTexts, teacherImageDivs} from "@/utils/Constants";
import * as boardCatApi from "@/api/notice/BoardCatApi";
import * as bannerApi from "@/api/exhibit/banner/BannerApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import swal from 'sweetalert2';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    components: {SchDateRange, SchText, ShowCounter, Pagenation, Loading},
    props: {
      type:{
        type:String,
        default:'brandBanner' // 'brandBanner':브랜드 배너, 'channelBanner' : 채널배너
      }
    },
    setup(props, {root}) {
      const isTest = false;
      const modalLoading = ref(false);

      const _dataObject = _.cloneDeep(dataObject);
      _dataObject.enabledSaveExhibition = computed({
        get() {
          return data.selectedBanners.length > 0;
        }
      });
      _dataObject.selectedBanners = [];
      _dataObject.selectAllBanner = computed({
        get() {
          return data.list.length ? data.selectedBanners.length == data.list.length : false;
        },
        set(newValue) {
          let selected = [];
          if (newValue) {
            data.list.forEach(item => {
              selected.push(item.seq);
            });
          }
          data.selectedBanners = selected;
        }
      });
      _dataObject.bannerCategorys = new ValueTexts([]);
      _dataObject.params.boardCatSeq = null;
      _dataObject.params.imageDivCd = '';
      _dataObject.params.exhibitionStatus = '';
      if (props.type == 'brandBanner') {
        _dataObject.params.teacherUseYn = '';
        _dataObject.params.studentUseYn = '';
        _dataObject.params.tutorUseYn = '';
        _dataObject.params.parentsUseYn = '';
      } else {
        _dataObject.params.teacherUseYn = undefined;
        _dataObject.params.studentUseYn = undefined;
        _dataObject.params.tutorUseYn = undefined;
        _dataObject.params.parentsUseYn = undefined;
      }
      _dataObject.selectAllUserType = computed({
        get() {
          return data.params.teacherUseYn === 'Y' && data.params.tutorUseYn === 'Y'
          && data.params.studentUseYn === 'Y' && data.params.parentsUseYn === 'Y';
        },
        set(newValue) {
          const ynValue = newValue ? 'Y' : '';
          data.params.teacherUseYn = ynValue;
          data.params.tutorUseYn = ynValue;
          data.params.studentUseYn = ynValue;
          data.params.parentsUseYn = ynValue;
        }
      });
      const data = reactive(_dataObject);

      data.exhibitionYns = new ValueTexts([
        {value:'', text:'전체'},
        {value:'Y', text:'Y'},
        {value:'N', text:'N'}
      ]);
      data.imageDivOption = new ValueTexts(teacherImageDivs);

      const retVals = {
        isTest,
        modalLoading,
        data,
        ...methods(props, data),
        dataAction: new TableActionClass(data),
        localSort:root.$_localSort
      }

      methods(props, data).reset();

      onMounted(async () => {
        await retVals.getBannerCategorys();
        if (store.state.params.name == props.type) {
          const storedData = store.state.params.data;
          retVals.data.params = storedData;
          store.commit('setParams', {name:'', data:undefined});
        } else {
          retVals.reset();
        }
        await retVals.search();
      });
      watch(() => props.type, async (params, oldParams) => {
        console.log(`watch:${oldParams} => ${params}`);
        await retVals.getBannerCategorys();
        await retVals.resetSearch();
      });

      return retVals;
    }
}

function methods(props, data) {

  async function getBannerCategorys() {
    const bannerCategorys = [];
    bannerCategorys.push({
      value:null,
      text:'전체'
    })
    const catType = props.type == 'brandBanner' ? '06' : '07';
    const catResult = await boardCatApi.getBoardCatList(catType);
    if (catResult.data) {
      catResult.data.forEach((item) => {
        bannerCategorys.push({
          value: item.seq,
          text : item.categoryName
        })
      })
    }
    data.bannerCategorys.setArray(bannerCategorys);
  }

  // 조건 리셋후 검색
  async function resetSearch() {
      await this.reset();
      await this.search();
  }

  function reset() {
    console.log('reset:', props, data);

    if (props.type == 'brandBanner') {
      data.title = '브랜드사이트 배너';
      data.url = '/exhibit/brandBannerList';
    } else {
      data.title = '채널 배너';
      data.url = '/exhibit/channelBannerList';
    }
    data.params.boardCatSeq = null;
    data.params.exhibitionStatus = '';
    data.params.imageDivCd = '';
    if (props.type == 'brandBanner') {
      data.params.teacherUseYn = '';
      data.params.studentUseYn = '';
      data.params.tutorUseYn = '';
      data.params.parentsUseYn = '';
    } else {
      data.params.teacherUseYn = undefined;
      data.params.studentUseYn = undefined;
      data.params.tutorUseYn = undefined;
      data.params.parentsUseYn = undefined;
    }
    
    data.params.schType = '';
    data.params.schText = '';
  }

  // 목록
  async function search(page) {
    console.log('search:', data);

    if (!isNaN(page)) {
      data.params.page = page;
    }
    data.params.title = data.params.schText;

    let result = undefined;
    if (props.type == 'brandBanner') { // 브랜드 배너
      result = await bannerApi.getBrandBannerList(data.params, this.isTest);
      if (result.data) {
      result.data.forEach((item) => {
        let userTypes = [];
        if (item.teacherUseYn == 'Y') userTypes.push('교사');
        if (item.tutorUseYn == 'Y') userTypes.push('강사');
        if (item.studentUseYn == 'Y') userTypes.push('학생');
        if (item.parentsUseYn == 'Y') userTypes.push('학부모');
        item.bannerUserTypes = userTypes.join(',');
      });
    };
    } else { // 채널 배너
      result = await bannerApi.getChannelBannerList(data.params, this.isTest);
    }
    
    data.list = result.data;
    data.count = result.count;
    this.localSort.set(data.list);
  }

  // 변경사항 프론트 반영 : 전시여부/노출순서 일괄변경
  async function saveExhibition() {
    let params = [];
    data.list.forEach((item) => {
      if (data.selectedBanners.includes(item.seq)) {
        params.push({
          seq : item.seq,
          exhibitionStatus : item.exhibitionStatus,
          orderNum : item.orderNum
        })
      }
    });
    const result = await bannerApi.saveBannerList(params);
    swal({
      title: "변경사항 반영 완료 ",
      text: " 변경사항 프론트 반영이 완료되었습니다. ",
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "OK",
      heightAuto: false
    }).then((result) => {
    });
  }

  // 상세
  async function goDetail(seq){
    this.$store.commit('setParams', {name:props.type, data:data.params});
    const urlName = props.type == 'brandBanner' ? 'brandBannerDetail' : 'channelBannerDetail';
    this.$router.push({name:urlName, params:{type:props.type, seq:seq, bannerCategorys:data.bannerCategorys.noEmptyArray}});
  }

  return {
    getBannerCategorys,
    resetSearch,
    reset,
    search,
    saveExhibition,
    goDetail,
  }
}
</script>